import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const formFieldDefaultVariants = {}
const formFieldCompoundVariants = []

const formFieldSlotNames = [
  [
    "root",
    "form__root"
  ],
  [
    "label",
    "form__label"
  ],
  [
    "message",
    "form__message"
  ]
]
const formFieldSlotFns = /* @__PURE__ */ formFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, formFieldDefaultVariants, getSlotCompoundVariant(formFieldCompoundVariants, slotName))])

const formFieldFn = memo((props = {}) => {
  return Object.fromEntries(formFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const formFieldVariantKeys = []
const getVariantProps = (variants) => ({ ...formFieldDefaultVariants, ...compact(variants) })

export const formField = /* @__PURE__ */ Object.assign(formFieldFn, {
  __recipe__: false,
  __name__: 'formField',
  raw: (props) => props,
  variantKeys: formFieldVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, formFieldVariantKeys)
  },
  getVariantProps
})